import { Amount } from '@ui/components/Amount/Amount';
import { HStack, styled } from 'styled-system/jsx';

import { useFromInput } from '../../hooks/useFromInput';
import { useTradingPair } from '../../store/useTradingPair';
import { useToAmount } from './hooks/useToAmount';

export const ToAmount = () => {
  const inputUsd = useFromInput((s) => s.input).value.usd; // fromUsd
  const toAmount = useToAmount(inputUsd);
  const tradingPair = useTradingPair((s) => s.useTradingPair());

  return (
    <HStack>
      <styled.img
        src={tradingPair?.image}
        alt="token icon"
        width="12px"
        height="12px"
      />
      <Amount
        textStyle="headings.small"
        value={toAmount}
        defaultUndefinedDisplay="Not Set"
        opts={{
          suffix: ` ${tradingPair?.baseSymbol}`,
          // for amount can display 6 decimals
          displayDecimals: 6,
        }}
        data-cy={`ToAmount-${tradingPair?.baseSymbol}`}
        data-cy-value={toAmount}
      />
    </HStack>
  );
};
